<template>

  <v-container
    v-if="supplier && countries"
    :style="{width: '100%', maxWidth: '960px'}"
    ref="parent"
    fluid
  >

    <v-card outlined class="ma-2" style="margin-bottom: 58px !important;">
      <v-card-title v-once>
        {{supplier.contact.name || 'Create'}}
      </v-card-title>
      <v-divider class="mx-4"/>
      <v-card-text>

        <v-row no-gutters>
          <v-col cols="12">
            <div class="subtitle-1 font-weight-black ma-1">Detalii</div>
          </v-col>
          <v-col cols="12">
            <v-text-field v-model="supplier.contact.name" label="Nume" class="ma-1" outlined dense hide-details/>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field v-model="supplier.financial.cui" label="CUI" class="ma-1" outlined dense hide-details/>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field v-model="supplier.financial.reg_com" label="Nr. Reg. Comercial" class="ma-1" outlined dense hide-details/>
          </v-col>
          <v-col cols="12">
            <div class="subtitle-1 font-weight-black ma-1">Bancă</div>
          </v-col>
          <v-col cols="12">
            <v-text-field v-model="supplier.financial.bank.name" label="Nume" class="ma-1" outlined dense hide-details/>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field v-model="supplier.financial.bank.iban" label="IBAN" class="ma-1" outlined dense hide-details/>
          </v-col>
          <v-col cols="12" md="6">
            <v-select v-model="supplier.financial.bank.currency" label="Valută" :items="currencies" item-text="value" class="ma-1" outlined dense hide-details/>
          </v-col>

          <v-col cols="12">
            <div class="subtitle-1 font-weight-black ma-1">Adresă</div>
          </v-col>
          <v-col cols="12">
            <v-text-field v-model="supplier.contact.address" label="Adresă" class="ma-1" outlined dense hide-details/>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field v-model="supplier.contact.city" label="Oraș" class="ma-1" outlined dense hide-details/>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field v-model="supplier.contact.region" label="Județ" class="ma-1" outlined dense hide-details/>
          </v-col>
          <v-col cols="12" md="4">
            <v-autocomplete v-model="supplier.contact.country" :items="countries" label="Țară" class="ma-1" outlined dense hide-details/>
          </v-col>
          <v-col cols="12">
            <div class="subtitle-1 font-weight-black ma-1">Email</div>
          </v-col>
          <v-col cols="12" v-for="(email, index) in supplier.contact.emails" :key="`email_${index}`">
            <v-card class="ma-1" outlined>
              <v-card-text class="pa-1">
                <v-row no-gutters align="center">
                  <v-col cols="12" md="11">
                    <v-row no-gutters>
                      <v-col cols="12" md="6">
                        <v-text-field v-model="email.name" label="Nume" class="ma-1" outlined dense hide-details/>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-text-field v-model="email.email" label="Email" class="ma-1" outlined dense hide-details/>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" md="1">
                    <div class="ma-1">
                      <v-btn height="40" color="delete white--text" depressed block @click="removeEmail(email)">
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" class="text-right">
            <v-btn color="create white--text" depressed class="ma-1" @click="addEmail">
              <v-icon left>mdi-plus</v-icon>
              Adaugă
            </v-btn>
          </v-col>
          <v-col cols="12">
            <div class="subtitle-1 font-weight-black ma-1">Telefon</div>
          </v-col>
          <v-col cols="12" v-for="(phone, index) in supplier.contact.phone_numbers" :key="`phone_${index}`">
            <v-card class="ma-1" outlined>
              <v-card-text class="pa-1">
                <v-row no-gutters align="center">
                  <v-col cols="12" md="11">
                    <v-row no-gutters>
                      <v-col cols="12" md="6">
                        <v-text-field v-model="phone.name" label="Nume" class="ma-1" outlined dense hide-details/>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-text-field v-model="phone.number" label="Numar" class="ma-1" outlined dense hide-details/>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" md="1">
                    <div class="ma-1">
                      <v-btn height="40" color="delete white--text" depressed block @click="removePhone(email)">
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" class="text-right">
            <v-btn color="create white--text" depressed class="ma-1" @click="addPhone">
              <v-icon left>mdi-plus</v-icon>
              Adaugă
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card outlined v-resize="onResize" :width="dynamic_width" class="ma-2" :style="{position: 'fixed', bottom: 0, maxWidth: '960px'}">
      <v-card-actions>
        <v-btn v-if="supplier.id" depressed color="delete white--text" @click="destroy" :loading="deleting" :disabled="deleting">
          <v-icon left>mdi-delete</v-icon>
          Șterge
        </v-btn>
        <v-spacer/>
        <v-btn depressed color="primary white--text" @click="save" :loading="saving" :disabled="saving">
          <v-icon left>mdi-floppy</v-icon>
          Salvează
        </v-btn>
      </v-card-actions>
    </v-card>

  </v-container>

</template>

<script>

  import default_supplier from '@/defaults/default-supplier'
  import supplier_repository from "@/repositories/supplier-repository";
  import config_repository from "@/repositories/config-repository";

  export default {
    data: () => ({
      supplier: null,
      countries: null,
      currencies: null,

      saving: false,
      deleting: false,

      dynamic_width: 0
    }),

    async created() {
      this.supplier = this.$route.params.supplier === 'create' ? _.cloneDeep(default_supplier) : await supplier_repository.getSupplier(this.$route.params.supplier);
      this.countries = await config_repository.getCountries();
      this.currencies = await config_repository.getCurrencies();
    },

    methods: {

      async save() {
        try {
          this.saving = true;
          this.supplier = await supplier_repository.saveSupplier(this.supplier);
          // await this.$store.dispatch('alert/success', 'Success');
          this.$route.params.supplier === 'create' ? await this.$router.push(`/suppliers/${this.supplier.id}`) : null;
        } catch (e) {
          await this.$store.dispatch('alert/error', e);
        } finally {
          this.saving = false;
        }
      },

      async destroy() {
        try {
          this.deleting = true;
          await supplier_repository.destroySupplier(this.supplier.id);
          await this.$router.push(`/suppliers`);
          await this.$store.dispatch('alert/success', 'Success');
        } catch (e) {
          await this.$store.dispatch('alert/error', e);
        } finally {
          this.deleting = false;
        }
      },

      addEmail() {
        this.supplier.contact.emails.push({
          name: null,
          email: null,
        });
      },

      removeEmail(email) {
        this.supplier.contact.emails.splice(this.supplier.contact.emails.indexOf(email), 1);
      },

      addPhone() {
        this.supplier.contact.phone_numbers.push({
          name: null,
          number: null,
        });
      },

      removePhone(phone) {
        this.supplier.contact.phone_numbers.splice(this.supplier.contact.phone_numbers.indexOf(phone), 1);
      },

      onResize() {
        this.dynamic_width = this.$refs['parent'].clientWidth - 40;
      }
    }
  }

</script>